import React, { useState } from "react";
import PayrollRun from "./PayrollRun";
import SalaryProfiles from "./SalaryProfiles";
import Adjustments from "./Adjustments";
import PayrollSettings from "./PayrollSettings";
import { GAP } from "./layout";

const TABS = [
  { key: 1, label: "Payroll Run" },
  { key: 2, label: "Salary Profiles" },
  { key: 3, label: "Bonus & Advances" },
  { key: 4, label: "Rules" },
];

const SwitchPayroll = () => {
  const [step, setStep] = useState(1);

  const body = () => {
    switch (step) {
      case 2:
        return <SalaryProfiles />;
      case 3:
        return <Adjustments />;
      case 4:
        return <PayrollSettings />;
      default:
        return <PayrollRun onSetupProfiles={() => setStep(2)} />;
    }
  };

  return (
    <div className="p-8">
      <div
        className="bg-white rounded-lg border overflow-hidden"
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${TABS.length}, 1fr)`,
          gap: 4,
          padding: 4,
          marginBottom: GAP.xl,
        }}
      >
        {TABS.map((t) => (
          <div
            key={t.key}
            onClick={() => setStep(t.key)}
            className={`iskool-tab-item ${
              step === t.key ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">{t.label}</div>
          </div>
        ))}
      </div>
      <div>{body()}</div>
    </div>
  );
};

export default SwitchPayroll;
